import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ArticlePage from './pages/ArticlePage';
import LandingPage from './pages/LandingPage';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/articles" element={<ArticlePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
